export type FilterWizardConfig = {
  path: string;
  filters?: Array<string>;
};

export type FilterWizardValue = {
  filterKey: string;
  description?: string;
  image?: string;
  title?: string;
};

export type FilterWizardData = {
  description?: string;
  image?: string;
  values?: Array<FilterWizardValue>;
  title?: string;
};
